import { ManufacturerType } from 'types/manufacturer'
import { StoreType } from 'types/store'

export const FETCH_MANUFACTURERS = 'FETCH_MANUFACTURERS'
export const fetchManufacturersAction = (manufacturers: ManufacturerType[]) => {
  return {
    type: 'FETCH_MANUFACTURERS',
    payload: manufacturers,
  }
}

export const HANDLE_MANUFACTURERS = 'HANDLE_MANUFACTURERS'
export const handleManufacturersAction = (manufacturers: ManufacturerType[]) => {
  return {
    type: 'HANDLE_MANUFACTURERS',
    payload: manufacturers,
  }
}

export const INIT_MANUFACTURERS = 'INIT_MANUFACTURERS'
export const initManufacturersAction = () => {
  return {
    type: 'INIT_MANUFACTURERS',
    payload: null,
  }
}

export const SAVE_MANUFACTURER_STORES = 'SAVE_MANUFACTURER_STORES'
export const saveManufacturerStoresAction = (stores: StoreType[]) => {
  return {
    type: 'SAVE_MANUFACTURER_STORES',
    payload: stores,
  }
}
